module.exports = __webpack_public_path__ + "img/default-icon.4a1e642b.svg";